let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("94GxG")).then(() => parcelRequire('4NJ4u'));